.panel {
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
}

.heading {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
}

.hint {
	margin: 0;
	font-size: 0.875rem;
	line-height: 1.5;
	color: var(--ink-muted);
	text-wrap: pretty;
}

/* Wide-tracked digits, so a 5-digit code reads as five separate characters.
   Doubled class on purpose: Field's `.field input` carries a type selector,
   so a single class loses to it and the size here would be ignored. */
.codeInput.codeInput {
	text-align: center;
	font-size: 1.5rem;
	letter-spacing: 0.4em;
	text-indent: 0.4em;
}

.actions {
	display: flex;
	gap: var(--space-2);
	justify-content: flex-end;
}

.primary,
.secondary {
	border-radius: var(--radius-sm);
	padding: var(--space-2) var(--space-4);
	font: inherit;
	font-weight: 600;
	cursor: pointer;
}

.primary {
	background: var(--accent-sage);
	color: #fff;
	border: none;
}

.secondary {
	background: none;
	color: var(--ink-muted);
	border: 1px solid var(--border);
}

.primary:disabled,
.secondary:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.error {
	margin: 0;
	font-size: 0.875rem;
	line-height: 1.5;
	color: var(--accent-rose);
	text-wrap: pretty;
}
